var map = {
	"./ALE_1.jpg": 6842,
	"./ALE_2.jpg": 5354,
	"./ALE_3.jpg": 5588,
	"./ALE_4.jpg": 3353,
	"./ANTO_1.jpg": 3900,
	"./ANTO_2.jpg": 7756,
	"./ANTO_3.jpg": 9360,
	"./ANTO_4.jpg": 2771,
	"./GIOVANNI_1.png": 280,
	"./GIUSY_1.png": 9061,
	"./RICCARDO_1.png": 4183,
	"./SABRI_1.png": 3564,
	"./VIS_1.png": 2500,
	"./YUS_1.jpg": 2527,
	"./YUS_2.jpg": 8227,
	"./YUS_3.jpg": 1190,
	"./YUS_4.jpg": 5753,
	"./bgA.png": 6171,
	"./black-man.png": 9175,
	"./gameLogo.png": 7507,
	"./kidLogo.png": 5758,
	"./logo.png": 9786,
	"./mzLogo.png": 9905,
	"./phone.png": 3554,
	"./pic1.png": 4282,
	"./pic2.png": 9903,
	"./pic3.png": 4880,
	"./portrait.png": 5103,
	"./scratch.png": 7318,
	"./sirLogo.png": 7591,
	"./temp.jpg": 9183,
	"./vid.png": 5069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9037;